import React, { useEffect, useRef } from 'react';
import ContactCard from './ContactCard';
import { contactMethods } from '../../data/portfolioData';
import { setupScrollAnimations } from '../../utils/animations';
import './Contact.css';

const Contact = () => {
  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = setupScrollAnimations();
    cardsRef.current.forEach(card => {
      if (card) observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">LET'S CONNECT</span>
          <h2 className="section-title">Get In Touch</h2>
          <p className="section-subtitle">
            Available for QA opportunities and consulting projects
          </p>
        </div>

        <div className="contact-grid">
          {contactMethods.map((method, index) => (
            <div 
              key={index}
              ref={el => cardsRef.current[index] = el}
              style={{ opacity: 0 }}
            >
              <ContactCard
                icon={method.icon}
                title={method.title}
                value={method.value}
                link={method.link}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contact;
